import marker from "../../../../assets/images/integrations/screens/markerio/marker7.png";
import * as React from 'react';
export default {
  marker,
  React
};